"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetWebMessengerConfiguration = exports.isUseGetTenantApplicationsWebMessengerConfigurationEnabled = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _utils = require("../utils");
const isUseGetTenantApplicationsWebMessengerConfigurationEnabled = ({
  customerTypeId,
  isAnonymousUser,
  isUserVerified,
  relativeUrl,
  visitorSegment
}) => !!relativeUrl && isUserVerified && (isAnonymousUser || customerTypeId !== undefined && visitorSegment !== undefined);
exports.isUseGetTenantApplicationsWebMessengerConfigurationEnabled = isUseGetTenantApplicationsWebMessengerConfigurationEnabled;
const useGetWebMessengerConfiguration = () => {
  const {
    customerId,
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  // istanbul ignore next @preserve -- No need to test undefined tenant case.
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    customerTypeId,
    visitorSegment
  } = (0, _presentationHttp.useGetCustomerInfo)({
    customerId
  });
  // istanbul ignore next @preserve -- No need to test isSSR.
  const relativeUrl = (0, _presentationUtils.isSSR)() ? undefined : (0, _utils.removeLanguageFromRelativeUrl)(window.location.pathname);
  return (0, _staticApiClientReact.useGetTenantApplicationsWebMessengerConfiguration)(tenant, {
    customerTypeId,
    relativeUrl,
    visitorSegment,
    lang: language
  }, {
    swr: {
      enabled: isUseGetTenantApplicationsWebMessengerConfigurationEnabled({
        customerTypeId,
        isAnonymousUser,
        isUserVerified,
        relativeUrl,
        visitorSegment
      }),
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    },
    request: {
      validateStatus: _fetching.validateStatus
    }
  });
};
exports.useGetWebMessengerConfiguration = useGetWebMessengerConfiguration;
